/**
 *
 * @module priceOrderRequestAddress
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    object,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class PriceOrderRequestAddress
 *
 */
export default class PriceOrderRequestAddress {

    /**
     *
     * @param {Object} [options={}]
     * @param {String} [options.zipCode=undefined]
     * @param {String} [options.city=undefined]
     * @param {String} [options.state=undefined]
     * @param {String} [options.country=undefined]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: 'PriceOrderRequestAddress(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get zipCode() {
                return `${this.ctor} zipCode should be a String with length`;
            },
            get city() {
                return `${this.ctor} city should be a String with length`;
            },
            get state() {
                return `${this.ctor} state should be a String with length`;
            },
            get country() {
                return `${this.ctor} country should be a String with length`;
            }
        };

        object(options, errorMessage.options, InvalidArgumentException);

        const { zipCode, city, state, country } = options;

        if (Check.assigned(zipCode)) {
            nonEmptyString(zipCode, errorMessage.zipCode, InvalidArgumentException);
        }

        if (Check.assigned(city)) {
            nonEmptyString(city, errorMessage.city, InvalidArgumentException);
        }

        if (Check.assigned(state)) {
            nonEmptyString(state, errorMessage.state, InvalidArgumentException);
        }

        if (Check.assigned(country)) {
            nonEmptyString(country, errorMessage.country, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.zipCode = zipCode;

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.city = city;

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.state = state;

        /**
         *
         * @access public
         * @type {String|undefined}
         *
         */
        this.country = country;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/priceOrderRequestAddress.js